<template>
  <div>
    <b-modal
    ref="modalCreateReturn" id="modalCreateReturn"
    v-on="$listeners"
    v-bind="$attrs"
    no-close-on-backdrop centered
      modal-class="dialog-600" >
       <template #modal-title>
        {{ dataModal.title }}
      </template>
      <form-render
        :form.sync="formReturns"
        :fields="dataModal.fields"
        containerButtonsClass="col-sm-12"
        @send="onSend"
        ref="formModals"
        :key="dataModal.keyformModals"
      >
      <template #n_packages="scope">
        <b-form-input v-model="formReturns.n_packages" :disabled="scope.field.disabled" :type="scope.field.type" id="n_packages" :state="!showAlertToolTip" ></b-form-input>
        <b-form-invalid-feedback id="n_packages_error">No es posible generar una devolución con más bultos que el envío original</b-form-invalid-feedback>
      </template>
      </form-render>
      <template #modal-footer>
        <b-button variant="warning" @click.prevent="onSend(formReturns)" :disabled="dataModal.loading || !isEnableButton">
        <b-spinner v-show="dataModal.loading" small></b-spinner>
        {{$t(dataModal.nameButton)}}
        </b-button>
      </template>
      </b-modal>
  </div>
</template>
<script>

export default {
  data() {
    return {
      formReturns: {},
      showAlertToolTip: false,
      isEnableButton: false
    }
  },
  props: {
    dataModal: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  computed: {
  },
  methods: {
    onSend(form) {
      this.$emit('onSend', form)
      this.$bvModal.hide('modalCreateReturn')
    }
  },
  watch: {
    'dataModal': {
      handler() {
        this.formReturns = {...this.dataModal.form}
      },
      deep: true
    },
    'formReturns.n_packages': {
      handler(newValue) {
        this.showAlertToolTip = newValue > this.dataModal.form.n_packages
        this.isEnableButton = !this.showAlertToolTip && !!this.formReturns?.carrier?.id
      },
      deep: true
    },
    'formReturns.carrier': {
      handler(newValue) {
        this.isEnableButton =  !this.showAlertToolTip && newValue?.id !== undefined
      },
      deep: true
    }
  }
}
</script>
<style>

</style>